<template>
  <v-dialog v-model="dialog" max-width="310" min-width="290" persistent>
    <v-layout align-center justify-center>
      <v-card color="rgb(255,255,255,0.9)" class="pa-3">
        <v-form>
          <v-text-field v-model="item_name" label="Item Name" required color="black"></v-text-field>
          <v-text-field v-model="marked_price" label="Marked Price" required color="black" hint="Amount for the Item"></v-text-field>
          <v-layout row wrap>
            <div class="mt-2 pt-1">
              <span class="subheading grey--text text--darken-1">Upload Photos</span>
            </div>
            <v-layout align-center column>
              <div class="ml-4 pl-1">
              <Upload
              @fileChosen="fileChosen1"
              :maxSize="maxSize"
              />
              <Upload
              @fileChosen="fileChosen2"
              :maxSize="maxSize"
              />
              <Upload
              @fileChosen="fileChosen3"
              :maxSize="maxSize"
              />
              </div>
            </v-layout>
          </v-layout>
          <v-autocomplete
            v-model="category"
            :items="categories"
            label="Category"
            persistent-hint
            color="black"
            >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition
                mode="out-in"
              >
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
          <v-layout row wrap justify-center class="mt-2">
            <v-btn @click="onback" large color="red" dark flat>Cancel</v-btn>
            <v-btn @click="onSubmit" large color="green" dark :loading="loading" flat>Submit</v-btn>
          </v-layout>
        </v-form>
      </v-card>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import firebase from 'firebase'
import Upload from "@/components/Upload.vue";
export default {
  data(){
    return{
      snackbar: false,
      color: '',
      mode: '',
      timeout: 0,
      text: '',
      category : null,
      item_name : null,
      marked_price : null,
      loading : false,
      maxSize : 512000,
      uploadFiles : [null, null, null],
      uploadedFilesURL : [],
      categories: [
        "Bicycle",
        "Books",
        "Electronics",
        "Furniture",
        "Lab Equipment",
        "Sports Equipment",
        "Other",
      ]
    }
  },
  components: {
    Upload
  },
  props: {
    dialog: Boolean
  },
  methods: {
    fileChosen1(e) {
      var vm = this;
      vm.uploadFiles[0] = e;
    },
    fileChosen2(e) {
      var vm = this;
      vm.uploadFiles[1] = e;
    },
    fileChosen3(e) {
      var vm = this;
      vm.uploadFiles[2] = e;
    },
    onSubmit() {
      var vm = this;
      var doc = null;
      var db = firebase.firestore();
      var storage = firebase.storage();
      var user = firebase.auth().currentUser;
      var storageRef = storage.ref().child('BuySell/'+user.uid);
      vm.loading = true;
      db.collection("posts_buy").add({
        posted_by : {
          uid : user.uid,
          avatar : user.photoURL,
          name : user.displayName
        },
        post_closed : false,
        accepted : [],
        rejected : [],
        interested : [],
        category : vm.category,
        marked_price : Number(vm.marked_price),
        item_name : vm.item_name,
        time_posted : new Date(Date.now())
      })
      .then(function (docRef) {
        doc = docRef.id;
        vm.color = "info";
        vm.text = "Uploading Files...";
        vm.snackbar = true;
        vm.uploadFiles.forEach(function(element, index) {
          if (element){
            storageRef.child(doc+'/'+index).put(element)
            .then(function (snapshot) {
              snapshot.ref.getDownloadURL()
              .then(function (downloadURL) {
                vm.uploadedFilesURL.push(downloadURL);
                db.collection("posts_buy").doc(doc).update({
                  photos : vm.uploadedFilesURL
                })
                .then(function () {
                  if (index==2){
                    vm.snackbar = true;
                    vm.text = "Files Uploaded Successfully.";
                    vm.color = "success";
                    setTimeout(vm.onSuccess(),1500);
                  }
                })
              })
            })
          }
          if (index==2){
            vm.onSuccess();
          }
        })
      })
      .catch(function (error) {
        vm.timeout = 4000;
        vm.loading = false;
        vm.text = error.message;
        vm.color = "error";
        vm.snackbar = true;
      })
    },
    onback() {
      this.$emit("hide", false);
    },
    onSuccess() {
      this.$emit("success");
    }
  }
};
</script>